import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { registerIcons } from '@/components/Icon/icons'
import { setupDirectives } from '@/directives/index'
import * as Sentry from '@sentry/vue'

import router from '@/router'
import App from '@/App.vue'

import 'normalize.css/normalize.css'
import '@/assets/font/iconfont.css'
import '@/styles/index.scss'

import 'fs-design/style'
// import { loadingDirective } from "fs-design"

registerIcons()
import 'amfe-flexible'

// 字体加载检测和降级处理
const checkFontLoading = () => {
  if ('fonts' in document) {
    // 检查 Open Sans 字体是否加载成功
    document.fonts.ready
      .then(() => {
        const openSansLoaded = document.fonts.check('12px "Open Sans"')

        console.log('[Font Check] Open Sans loaded:', openSansLoaded)

        // 详细检查加载的字体变体
        const loadedFonts = Array.from(document.fonts.values())
          .filter(font => font.family.includes('Open Sans'))
          .map(font => ({
            family: font.family,
            style: font.style,
            weight: font.weight,
            status: font.status,
          }))

        console.log('[Font Details] Loaded Open Sans variants:', loadedFonts)

        // 检查 body 元素的实际字体样式
        const bodyStyles = window.getComputedStyle(document.body)
        console.log('[Body Font] Computed styles:', {
          fontFamily: bodyStyles.fontFamily,
          fontStyle: bodyStyles.fontStyle,
          fontWeight: bodyStyles.fontWeight,
          fontStretch: bodyStyles.fontStretch,
        })

        // 检查是否所有字体都是斜体
        const allItalic = loadedFonts.every(font => font.style === 'italic')
        if (allItalic && loadedFonts.length > 0) {
          console.error('[Font Error] All loaded Open Sans fonts are italic! This is the root cause.')

          // 强制使用系统字体
          document.body.style.fontFamily =
            '-apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif'
          console.warn('[Font Fix] Switched to system fonts as fallback')
        }

        if (!openSansLoaded) {
          console.warn('[Font Warning] Open Sans font failed to load, falling back to system fonts')

          // 可选：上报字体加载失败事件
          if (import.meta.env.PROD) {
            Sentry.captureMessage('Open Sans font failed to load', 'warning')
          }
        } else {
          console.log('[Font Info] Open Sans font loaded successfully')
        }
      })
      .catch(error => {
        console.error('[Font Error] Font loading check failed:', error)
      })
  }
}

const pinia = createPinia()
const app = createApp(App)
setupDirectives(app)
app.use(pinia)
app.use(router)
// app.use(loadingDirective)
if (import.meta.env.PROD && import.meta.env.VITE_ENV_MODE === 'PROD') {
  Sentry.init({
    app,
    dsn: 'https://f71dbcc48fb04ba90fd0671ac572e196@sentry.fs.com/32',
    release: 'design-center',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}

app.mount('#mainApp')

// 在应用挂载后检查字体加载状态
checkFontLoading()
